import * as React from "react";
import { Route, Routes } from "react-router-dom";
import { Commands } from "../../../components/detail/commands";
import { CommandDetail } from "../../../components/detail/command";
import { BasePathContext } from "../../../reactContexts/basePathContext";

interface Props {
  itemLink: string;
  containerName?: string;
}
export const CommandsRoute: React.FC<Props> = ({ itemLink, containerName }) => {
  const basePath = React.useContext(BasePathContext);

  return (
    <Routes>
      <Route index element={<Commands selfLink={itemLink} />} />
      <Route path={`:commandId`} element={<CommandDetail itemLink={itemLink} containerName={containerName} />} />
    </Routes>
  );
};
